

import {
  LOAD_REPORTS_ERROR, LOAD_REPORTS_REQUEST, LOAD_REPORTS_SUCCESS,
  SET_REPORT_URL
} from "./reports-action-types";

export const loadReportsRequest = () => ({ type: LOAD_REPORTS_REQUEST });
export const loadReportsSuccess = reports => ({ type: LOAD_REPORTS_SUCCESS, reports });
export const loadReportsError = error => ({ type: LOAD_REPORTS_ERROR, error });

export const setReportUrl = reportUrl => ({ type: SET_REPORT_URL, reportUrl });


// WEBPACK FOOTER //
// ./src/modules/reports/reports-action-creators.js